// extracted by mini-css-extract-plugin
export var dataCell = "_hr-2";
export var dataRow = "_hr-0";
export var headerRow = "_hr-1";